import React, { useState, useEffect, useContext, useRef } from "react";
import { Form, Formik, Field } from "formik";
import { useHistory } from "react-router-dom";

import Layout from "components/Layout";
import Icon from "components/Icon";
import Subtitle from "components/SubTitle";
import { Col, Row } from "components/Grid";
import ContentCard from "components/ContentCard";
import { SelectField } from "components/Form/index";
import BrokingSummary from "components/BrokingSummary";

import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import { FitinsurAPI, MessageCenter } from "utils";
import Mask from 'utils/src/mask';

import Colors from "constants/Colors";

import {
  LabelTitle,
  LabelText,
  RowStyled,
  ColStyled,
  LabelTypePlan,
  LabelInfoPlan,
  ButtonContract,
  DivIcon,
  IconErrorOrGreen,
  Notice,
  ButtonContainer,
  Heading,
  BackToList
} from "./styles";

export default function Plans(props) {
  const roofings = [
    {
      idProductCoverage: 72,
      coverageName: "Responsabilidade Civil Profissional",
      label: "RC Profissional",
    },
    {
      idProductCoverage: 73,
      coverageName: "Custos de Defesa",
      label: "Custos de Defesa",
    },
    {
      idProductCoverage: 74,
      coverageName: "Difamação, Calúnia e Injúria",
      label: "Calúnia, Injúria e Difamação",
    },
    {
      idProductCoverage: 75,
      coverageName: "Custos Emergenciais",
      label: "Custos Emergenciais",
    },
    {
      idProductCoverage: 76,
      coverageName: "Despesas de Salvamento ",
      label: "Despesas de Salvamento",
    },
    {
      idProductCoverage: 77,
      coverageName: "Extravio e  Furto de Documentos",
      label: "Extravio e Furto de Documentos",
    },
    {
      idProductCoverage: 78,
      coverageName: "Lucros Cessantes",
      label: "Lucros Cessantes",
    },
    {
      idProductCoverage: 79,
      coverageName: "Novas Subsidiárias",
      label: "Novas Subsidiárias",
    },
    {
      idProductCoverage: 80,
      coverageName: "Comparecimento ao Tribunal",
      label: "Comparecimento ao Tribunal",
    },
    {
      idProductCoverage: 81,
      coverageName: "Danos Corporais ",
      label: "Danos Corporais",
    },
    {
      idProductCoverage: 82,
      coverageName: "Danos Materiais",
      label: "Danos Materiais",
    },
    {
      idProductCoverage: 83,
      coverageName: "Danos Morais",
      label: "Danos Morais",
    },
    {
      idProductCoverage: 84,
      coverageName: "Despesas de Publicidade",
      label: "Despesas de Publicidade",
    },
    {
      idProductCoverage: 85,
      coverageName: "Danos Autorais",
      label: "Danos Autorais",
    },
    {
      idProductCoverage: 86,
      coverageName: "Quebra de Sigilo Profissional",
      label: "Quebra de Sigilo Profissional",
    },
    {
      idProductCoverage: 87,
      coverageName: "Subcontratados",
      label: "Subcontratados",
    },
    {
      idProductCoverage: 88,
      coverageName: "Ato Desonesto de Empregados",
      label: "Atos Desonestos de Empregados",
    },
    {
      idProductCoverage: 89,
      coverageName:
        "Herdeiros, Sucessores, Representantes Legais, Espólio, Cônjuge e/ou Companheiro(a) dos Segurados",
      label: "Cônjuge, Espólio, Herdeiros e Representantes",
    },
    {
      idProductCoverage: 90,
      coverageName: "Indenização e Acordos",
      label: "Indenização e Acordos",
    },
    {
      idProductCoverage: 91,
      coverageName: "Honorários advocatícios",
      label: "Honorários Advocatícios",
    },
    {
      idProductCoverage: 92,
      coverageName: "Danos à Reputação",
      label: "Danos à Reputação",
    },
  ];

  const localConstants = {
    QUESTION_PARCELAMENTO: 181
  }

  const { idOperation,idProduct } = props?.match?.params;
  const [selectedPlan, setSelectedPlan] = useState(1);
  const [currentPlans, setCurrentPlans] = useState([]);
  const [statusOperation, setStatusOperation] = useState(null);
  const [quote, setQuote] = useState({
    idOperation: "",
    proponent: "",
    email: "",
    cpfOrCnpj: "",
    previousInsurer: "",
    susep: "",
    marketingBranches: [],
    sufferedComplaintsFiveYears: "",
    possibleComplaints: "",
    effectiveDate: "",
    retroactivity: "",
    annualBilling: "",
    transportBilling: "",
    idDomainStatus: "",
    product_plans: [],
    coverages: [],
    limits: [],
    payments: []
  });
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const history = useHistory();
  const fitinsurAPI = new FitinsurAPI();
  const mc = new MessageCenter();
  const initialValues = { payment: 1 };
  const formik = useRef(null);

  useEffect(() => {
    console.log("Itens rota", idOperation + idProduct);
    async function requestGetQuoteFormatted() {
      console.log("requestGetQuoteFormatted - BEGIN");
      loading.start();
      fitinsurAPI.setAuthToken(authContext.token);
      fitinsurAPI
        .requestGetQuote(idProduct, idOperation)
        // .requestGetQuote(15, 220791)
        .then((x) => x.json())
        .then((response) => {
          console.log("requestGetQuoteFormatted - requestGetQuote - BEGIN");
          if (response.ret_code != 200) {
            mc.error(response.ret_msg_details);
            return loading.stop();
          }
          const { ret_value } = response;
          console.log("requestGetQuoteFormatted - requestGetQuote - getUniqObjBeetweenSames");
          const getUniqObjBeetweenSames = (array) =>
            array
              .map((item) => ({
                answer: item.answer,
                idQuestion: item.idQuestion,
                dsQuestion: item.dsQuestion,
              }))
              .filter(
                (item, pos, self) =>
                  self.findIndex(
                    (v) =>
                      v.answer === item.answer &&
                      item.idQuestion == v.idQuestion
                  ) === pos
              );
          console.log("requestGetQuoteFormatted - requestGetQuote - risks");
          const risks = getUniqObjBeetweenSames(ret_value.risks);
          console.log("requestGetQuoteFormatted - requestGetQuote - operations");
          const operations = getUniqObjBeetweenSames(ret_value.operations);
          console.log("requestGetQuoteFormatted - requestGetQuote - payments");
          const payments = getUniqObjBeetweenSames(ret_value.payments);          
          console.log("requestGetQuoteFormatted - requestGetQuote - mapCoverages");
          const mapCoverages = ret_value.resultProductPlans.coverageCalc
            .map((item) => [
              ...item.coverageCalc.map((coverage) => ({
                ...coverage,
                idProductPlan: item.id_product_plan,
              })),
            ])
            .flat();
          console.log("requestGetQuoteFormatted - requestGetQuote - flatCoverages");
          const flatCoverages = mapCoverages.map((item) => item.coverageLimit);
          console.log("requestGetQuoteFormatted - requestGetQuote - limits");
          const auxLimits = flatCoverages.filter(
            (item, index, self) => self.indexOf(item) == index
          );
          console.log("requestGetQuoteFormatted - requestGetQuote - coverages");
          const coverages = auxLimits.map((limit) => {
            const plans = mapCoverages
              .map((item) => (item.coverageLimit == limit && item.coverageAmount > 0 ? item : false))
              .filter(Boolean);
            return {
              limit,
              plans,
            };
          });
          //02222021 BUGFIX 02
          const limits = auxLimits.sort((a, b) => { return a - b });
          setStatusOperation(ret_value.operation.idDomainStatus);
          console.log("requestGetQuoteFormatted - requestGetQuote - setQuote");
          setQuote({
            idOperation: ret_value.idOperation,
            proponent: ret_value.persons.find((item) => item.idQuestion == 145)
              .answer,
            email: ret_value.persons.find((item) => item.idQuestion == 144)
              .answer,
            cpfOrCnpj: ret_value.persons.find((item) => item.idQuestion == 143)
              .answer,
            previousInsurer: operations.find(
              ({ idQuestion }) => idQuestion == 148
            ).answer,
            susep: ret_value.persons.find((item) => item.idQuestion == 146)
              .answer,
            marketingBranches: risks
              .map(({ idQuestion, answer }) =>
                idQuestion == 150 ? answer : false
              )
              .filter(Boolean),
            sufferedComplaintsFiveYears: risks.find(
              ({ idQuestion }) => idQuestion == 152
            ).answer,
            possibleComplaints: risks.find(
              ({ idQuestion }) => idQuestion == 153
            ).answer,
            effectiveDate: risks.find(({ idQuestion }) => idQuestion == 154)
              .answer,
            retroactivity: risks.find(({ idQuestion }) => idQuestion == 163)
              .answer,
            annualBilling: risks.find(({ idQuestion }) => idQuestion == 149)
              .answer,
            transportBilling: risks.find(({ idQuestion }) => idQuestion == 151)
              .answer,
            product_plans: ret_value.resultProductPlans.product_plan,
            idDomainStatus: ret_value.operation.idDomainStatus,
            coverages,
            limits,
            payments
          });

          console.log("requestGetQuoteFormatted - requestGetQuote - END");
          loading.stop();
          handleCanEditOperation(idProduct,idOperation);
        })
        .catch((e) => {
          loading.stop();
          mc.error(e.message);
          console.log(e);
        });
    }
    requestGetQuoteFormatted();
  }, [statusOperation]);

  useEffect(() => {
    const plans = quote.coverages.find((item) => item.limit === quote.limits[selectedPlan - 1]);
    if (plans) {
      setCurrentPlans(plans.plans);
    }
  }, [quote, selectedPlan]);

  const getPayment = (insurer, coverageAmount) => {

    let installmentTotal;
    let options = [];
    installmentTotal = insurer === "Fator" ? 5 : 7;

    for (let index = 0; index < installmentTotal; index++) {

      let installmentValue = coverageAmount / (index + 1);
      let optionLabel=index === 0 ? `Á vista` : `${index + 1}x Sem Juros de ` + `${Mask.currency({
        value: installmentValue,
        lang: "pt-br",
        currency: 'BRL',
        style: 'currency'
        })}`;
      let option = {
          label: optionLabel, 
          value: optionLabel
          //label: index === 0 ? `Á vista` : `${index + 1}x Sem Juros`,
          //value: `${index + 1}`
      };

      //20210314 - minor fix - error "options not iterable" no componente selectField
      if (insurer === "Argo" && installmentValue < 100) {
        //return;
      } else {
        options.push(option);  
      }
      //options.push(option);
    };

    return options;
  };

  const handleSelectPlan = (currentPlan, optionLabel) => {
    loading.start();

    let body = {
      idOperation: idOperation,
      idProductPlan: currentPlan.idProductPlan,
      idProductPlanCoverage: currentPlan.idProductPlanCoverage,
      optionLabel,
      currentPlan,
      add_step: 3,
    };

    // grava opcao de parcelamento no questionario de pagamento
    let paymentQuest = quote.payments.map((item)=>{
      let result = {
        idAnswerOption: null,
        idDomainPersonRole: item.idOperationPersonRole,
        idQuestion: Number(item.idQuestion),
        idQuestionnaire: item.idQuestionaire,
        questionDomain: item.idDomainQuestion,
        textQuestionAnswer: (Number(item.idQuestion)==Number(localConstants.QUESTION_PARCELAMENTO) 
          ? formik.current.values["payment"]
          : item.answer)
      };      
      return result;
    })

    fitinsurAPI.setAuthToken(authContext.token);
    // grava opcao de pagamento - add step 4
    fitinsurAPI
      .requestAddAction4(paymentQuest, idOperation)
      .then((response)=>response.json())      
      .then((data)=>{
        if (!data.ret_code || data.ret_code !== 200) {
          throw new Error("ERROR "+data.ret_code+" "+data.ret_msg);
        }
        // grava selecao do plano - add step 3
        fitinsurAPI.requestAddAction3(body)
        .then((response) => response.json())
        .then((data) => {
          loading.stop();
          if (data.ret_code === 200) {
            history.push({
              pathname: `/quotes/payments/${idProduct}/${idOperation}`,
              state: { plan: currentPlan, quote: quote, option: optionLabel, personRole: props.location?.state?.personRole }
            })
          } else {
            mc.error("Erro ao escolher o plano");
          }
        })
        .catch((e) => {
          loading.stop();
          console.log(e);
          mc.error("Erro ao escolher o plano");
        });        
      })
      .catch((e)=>{
        loading.stop();
        console.log(e);
        mc.error("Erro atualizando forma de pagamento");        
      });
      
  }

  const renderColTypePlans = (label, isActive, index, onClick) => (
    <ColStyled
      md={4}
      isActive={isActive === index}
      index={index}
      onClick={onClick}
    >
      <LabelTypePlan>
        {label && Mask.currency({
          value: label,
          lang: "pt-br",
          currency: 'BRL',
          style: 'currency'
        })}
      </LabelTypePlan>
    </ColStyled>
  );

  const renderCardPlan = (optionLabel, data, isLast) => {
    const info = quote.product_plans.find(plan => plan.id_product_plan === data.idProductPlan);

    return (
      <Col md={3} style={{ paddingRight: 0, paddingLeft: 0 }}>
        <ContentCard
          title={`OPÇÃO ${optionLabel}`}
          noBorder
          noPadding
          customShadow={`box-shadow: 0px 8px 12px 0px ${Colors.GRAY[4]};`}
          mr={12}
          mt={10}
        >
          <Icon
            name={info.product_plan_name.indexOf('Argo') >= 0 ? "logoArgo" : "logoFator"}
            style={{ marginTop: 15, marginBottom: 11 }}
          />
          <LabelInfoPlan fs={17} center color="#666666" mnh={52} mxh={52} largeWidth={!isLast}>
            {data.coverageAmount && Mask.currency({
              value: data.coverageAmount,
              lang: "pt-br",
              currency: 'BRL',
              style: 'currency'
            })}
          </LabelInfoPlan>
          <LabelInfoPlan
            pb={11}
            pt={11}
            pl={12}
            color="#666666"
            mxh={84}
            mnh={84}
            center
            largeWidth={!isLast}
          >
            {data.deductibleDescription}
          </LabelInfoPlan>
          <div
            style={{
              minHeight: 170,
              maxHeight: 170,
              paddingTop: 15,
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            <Formik
              innerRef={formik}
              initialValues={initialValues}
              onSubmit={() => null}
            >
              {(formikProps) => (
                <Form>
                  <Field
                    placeholder="Parcelamento"
                    name="payment"
                    value={formikProps.values.payment}
                    type="text"
                    readOnly
                    //options={[{ label: "7X sem juros = 0+7 de R$ 110,72", value: 1 }]}
                    options={getPayment(info.product_plan_name.indexOf('Argo') >= 0 ? "Argo" : "Fator", data.coverageAmount)}
                    component={SelectField}
                  />
                </Form>
              )}
            </Formik>
            <ButtonContract onClick={() => handleSelectPlan(data, optionLabel)}>
              <LabelInfoPlan
                nbb
                fs={16}
                lh={24}
                pt={0}
                pb={0}
                center
                color="#FFFFFF"
              >
                CONTRATAR
              </LabelInfoPlan>
            </ButtonContract>
          </div>
          {roofings.map((item, key) => (
            <DivIcon key={key} isFirst={key === 0} isLast={isLast}>
              {data.coverageItems.find(
                (coverage) =>
                  coverage.idProductCoverage == item.idProductCoverage
              ) ? (
                  <IconErrorOrGreen name="okGreen" style={{ minHeight: 32, maxHeight: 32 }} isLast={isLast} />
                ) : (
                  <IconErrorOrGreen name="closeRed" style={{ minHeight: 32, maxHeight: 32 }} isLast={isLast} />
                )}
            </DivIcon>
          ))}

          <LabelInfoPlan
            pt={8}
            pb={8}
            color="#666666"
            mxh={56}
            mnh={56}
            nbb
            center
          >
            {info.susep_process}
          </LabelInfoPlan>
        </ContentCard>
      </Col>
    );
  };

  const handleCanEditOperation = function(idProduct,idOperation){
    console.log("handleCanEditOperation - statusOperation: ",statusOperation);
    const domainStatus={
      QUOTE_LOST: 2,
      QUOTE_ISSUED: 5
    }
    const result=(!statusOperation
      || (statusOperation!=domainStatus.QUOTE_LOST 
        && statusOperation!=domainStatus.QUOTE_ISSUED) );

    console.log("handleCanEditOperation - result: ",result);

    if (!result){
      mc.success(`Cotação ${idOperation} já emitida. Verifique na pasta de documentos.`);
      history.push(`/documents/${idProduct}/${idOperation}`);      
    }    
  }

  return (
    <Layout
      title="Nova Cotação"
      subtitle="Responsabilidade Civil Profissional Corretor de Seguros"
    >
      <Subtitle
        idProduct={idProduct}
        idOperation={idOperation}
        stage={2}
        statusOperation= {statusOperation}
        cantGoBack={props.location?.state?.isFromList}
      />

      <BrokingSummary data={quote} />
      <ContentCard
        title="OPÇÕES DE PLANOS E LIMITES (SELECIONE UM DOS LIMITES ABAIXO)"
        noPadding
        noBorder
        noShadow
        noBorderRadius
        customShadow=""
      >
        <RowStyled>
          {quote.limits.map((item, index) =>
            renderColTypePlans(item, selectedPlan, index + 1, () =>
              setSelectedPlan(index + 1)
            )
          )}
        </RowStyled>

        {currentPlans.length > 0 ?
          <Row>
            <Col md={3} style={{ paddingRight: 0 }}>
              <div style={{ height: 70 }} />
              <LabelInfoPlan pb={11} mnh={105} mxh={105} flexEnd>
                Prêmio Total (Valor a ser pago)
            </LabelInfoPlan>
              <LabelInfoPlan pb={21} pt={21} mxh={84} mnh={84}>
                Franquia
            </LabelInfoPlan>
              <LabelInfoPlan pt={18.5} pb={80} nbb mnh={140} mxh={140}>
                Selecione o Parcelamento
            </LabelInfoPlan>
              <LabelInfoPlan pb={5} fs={15} lh={22.5} mnh={32} mxh={32}>
                COBERTURAS
            </LabelInfoPlan>

              {roofings.map((item, key) => (
                <LabelInfoPlan key={key} mnh={60} mxh={60} fs={14} lh={21}>
                  {item.label}
                </LabelInfoPlan>
              ))}

              <LabelInfoPlan pb={15} pt={13} fs={15} lh={22.5} nbb>
                PROCESSO SUSEP
            </LabelInfoPlan>
            </Col>
            {/*BUGFIX04 02182021*/}
            {currentPlans.map((item, index) => renderCardPlan(`${index + 1}`, item, index === currentPlans.length - 1))}
          </Row>
          :
          <Notice>
            <h4>Obrigado por seu interesse! </h4>
            <label>No momento, não temos planos disponíveis para este limite</label>
          </Notice>
        }
      </ContentCard>
      <ButtonContainer>
        <BackToList onClick={() => history.push("/quotes")}>
          <Icon name="vector" />
          <Heading style={{ fontSize: 16 }}>VOLTAR PARA LISTA</Heading>
        </BackToList>
      </ButtonContainer>
    </Layout >
  );
}
